module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Model-Q-0809.c51dc30e.jpg";